import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
    deleteProfilePlayerAudio,
    deleteProfilePlayerSubtitles,
} from 'store/player/actions';
import { selectPlayerConfig } from 'store/player/selectors';
import { selectProfilesList } from 'store/user/selectors';

function useUpdateProfileSettings(isFtiFlow: boolean) {
    const dispatch = useDispatch();

    const { subtitles, audio } = useSelector(selectPlayerConfig);
    const profiles = useSelector(selectProfilesList);

    useEffect(() => {
        if (isFtiFlow) {
            const subtitlesProfileIds = Object.keys(subtitles);
            const audioProfileIds = Object.keys(audio);
            const profileIds = profiles.map(({ _id }) => _id);
            const deletedSubtitlesProfileIds = subtitlesProfileIds.filter(
                (id) => !profileIds.includes(id),
            );
            const deletedAudioProfileIds = audioProfileIds.filter(
                (id) => !profileIds.includes(id),
            );

            if (deletedSubtitlesProfileIds.length) {
                deletedSubtitlesProfileIds.forEach((id) =>
                    dispatch(deleteProfilePlayerSubtitles(id)),
                );
            }

            if (deletedAudioProfileIds.length) {
                deletedAudioProfileIds.forEach((id) =>
                    dispatch(deleteProfilePlayerAudio(id)),
                );
            }
        }
    }, [isFtiFlow, profiles, subtitles, audio, dispatch]);
}

export default useUpdateProfileSettings;
